import { render, staticRenderFns } from "./OwnClassTeacher.vue?vue&type=template&id=9eeff27c"
import script from "./OwnClassTeacher.vue?vue&type=script&lang=js"
export * from "./OwnClassTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports